import { getRequest } from '../services/requestHandler';
import { PlayerInternalStatuses } from '../models';

export const getPlayerInternalStatuses = async () => {
  // available param playerStatusLookupId to reduce response if needed when online
  const url = `player/GetplayerInternalStatuses?useCache=true`;
  const response = await getRequest<PlayerInternalStatuses>('GetplayerInternalStatuses', url);
  return response;
};
